export default "__VITE_ASSET__D7CTR0Wd__"